import __request__ from "routing/request";
export function search(JSONBody, requestOptions) {
  return __request__("POST", "/quickjump", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
